import React, { useState } from 'react';
import s from "./SettingsMenu.module.css"
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../../hooks/mobileHook';
import { List, Collapse, ListItemButton, ListItemText } from '@mui/material';

export default function SettingMenu({ onMenuChange }) {
    const [activeItem, setActiveItem] = useState('item1');
    const [dropdowns, setDropdowns] = useState({});
    const navigate = useNavigate();
    const handleBackClick = () => { navigate('/devices'); };

    const toggleDropdown = (id) => {
        setDropdowns(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    return (
        <div className={s.sideBarFrame}>
            <div className={s.forwardback} onClick={handleBackClick}>
                <div className={s.backIcon}>
                    <img src={'/forwardback.svg'}></img>
                </div>
                <div className={s.forwardbackText}>Назад</div>
            </div>
            <div className={s.sideBarBox}>
                <div className={s.sideBarGroup}>
                    <MenuItem
                        text="Адреса"
                        isActive={activeItem === 'item1'}
                        onClick={() => {
                            onMenuChange('address');
                            setActiveItem('item1')
                        }}
                    >
                    </MenuItem>

                    <MenuItem
                        text="Организации"
                        isActive={activeItem === 'item2'}
                        onClick={() => {
                            setActiveItem('item2');
                            onMenuChange('organization');
                        }}
                    ></MenuItem>

                    <MenuItem
                        text="Группы"
                        isActive={activeItem === 'item3'}
                        onClick={() => {
                            setActiveItem('item3');
                            onMenuChange('group');
                        }}
                    ></MenuItem>

                    <MenuItem
                        text="Шлюзы (LoRaWan)"
                        isActive={activeItem === 'item4'}
                        onClick={() => {
                            setActiveItem('item4');
                            onMenuChange('createGateway');
                        }}
                    ></MenuItem>

                    <MenuItem
                        text='Пользователи'
                        isActive={activeItem === 'item5'}
                        onClick={() => {
                            onMenuChange('users');
                            setActiveItem('item5');
                        }}
                    >
                    </MenuItem>
                </div>
            </div>
        </div>
    )
}

function MenuItem({ text, isActive, onClick, children }) {
    return (
        <>
            <div
                className={`${s.menuItem} ${isActive ? s.active : ''}`}
                onClick={onClick}
            >
                <div className={s.articleText}>{text}</div>
            </div>
            {children}
        </>
    );
}